import { render, staticRenderFns } from "./regionalAd.vue?vue&type=template&id=21d357eb&scoped=true&"
import script from "./regionalAd.vue?vue&type=script&lang=js&"
export * from "./regionalAd.vue?vue&type=script&lang=js&"
import style0 from "./regionalAd.vue?vue&type=style&index=0&id=21d357eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d357eb",
  null
  
)

export default component.exports